/*
		version 0.1
	*/
(function(){
	
    angular
        .module('tmx-app')
        .controller('TmxAppCtrl', ['$mdSidenav','$http','$state','menu','ProgressBar',TmxAppCtrl]);

    function TmxAppCtrl($mdSidenav,$http,$state,menu,ProgressBar) { 
        var vm=this;
        vm.menu=menu;
        vm.showTopProgress = ProgressBar.isVisible;
        loadMenu(vm,$http,"assets/sections.json");
    }


    function loadMenu(main,http,URL){
        var config={
            method:'GET',
            url:URL,
            headers:{
                'Content-Type':'json'
            }
        };

        http(config).then(
            function(response){
                main.menu.pages=response.data;
            }
            ,
            function(response){
                main.menu={};
            }
        );
    }

})();

